import * as React from 'react';
export const swishSvg = React.forwardRef(function swishSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#F6F8FA',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fill: 'url(#bi_swish__a)',
      fillRule: 'evenodd',
      d: 'M10.827 26.832c4.82 2.305 10.77 1.164 14.366-3.12 4.26-5.075 3.6-12.644-1.478-16.903l-3.376 4.021a9.372 9.372 0 0 1 1.155 13.206c-2.653 3.163-7.024 4.218-10.667 2.794',
      clipRule: 'evenodd',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fill: 'url(#bi_swish__b)',
      fillRule: 'evenodd',
      d: 'M10.827 26.832c4.82 2.305 10.77 1.164 14.366-3.12.441-.523.827-1.075 1.163-1.647a10.493 10.493 0 0 0-3.617-9.72 10.497 10.497 0 0 0-2.398-1.515 9.374 9.374 0 0 1 1.154 13.206c-2.653 3.163-7.024 4.218-10.667 2.794',
      clipRule: 'evenodd',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fill: 'url(#bi_swish__c)',
      fillRule: 'evenodd',
      d: 'M21.175 5.168c-4.821-2.305-10.771-1.164-14.367 3.12-4.26 5.076-3.6 12.644 1.479 16.903l3.375-4.021a9.372 9.372 0 0 1-1.155-13.206c2.654-3.163 7.025-4.22 10.668-2.796Z',
      clipRule: 'evenodd',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fill: 'url(#bi_swish__d)',
      fillRule: 'evenodd',
      d: 'M21.175 5.168c-4.821-2.305-10.771-1.164-14.367 3.12a11.99 11.99 0 0 0-1.163 1.647 10.493 10.493 0 0 0 3.618 9.72c.746.626 1.553 1.13 2.398 1.515a9.374 9.374 0 0 1-1.155-13.206c2.655-3.163 7.026-4.22 10.669-2.796Z',
      clipRule: 'evenodd',
    }),
    /*#__PURE__*/ React.createElement(
      'defs',
      null,
      /*#__PURE__*/ React.createElement(
        'linearGradient',
        {
          id: 'bi_swish__a',
          x1: 19.869,
          x2: 14.753,
          y1: 21.674,
          y2: 11.407,
          gradientUnits: 'userSpaceOnUse',
        },
        /*#__PURE__*/ React.createElement('stop', {
          stopColor: '#EF2131',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 1,
          stopColor: '#FECF2C',
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'linearGradient',
        {
          id: 'bi_swish__b',
          x1: 23.985,
          x2: 15.145,
          y1: 13.155,
          y2: 28.628,
          gradientUnits: 'userSpaceOnUse',
        },
        /*#__PURE__*/ React.createElement('stop', {
          stopColor: '#FBC52C',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.26,
          stopColor: '#F87130',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.56,
          stopColor: '#EF52E2',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 1,
          stopColor: '#661EEC',
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'linearGradient',
        {
          id: 'bi_swish__c',
          x1: 12.184,
          x2: 17.062,
          y1: 10.18,
          y2: 20.064,
          gradientUnits: 'userSpaceOnUse',
        },
        /*#__PURE__*/ React.createElement('stop', {
          stopColor: '#78F6D8',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.27,
          stopColor: '#77D1F6',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.55,
          stopColor: '#70A4F3',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 1,
          stopColor: '#661EEC',
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'linearGradient',
        {
          id: 'bi_swish__d',
          x1: 8.021,
          x2: 16.861,
          y1: 18.849,
          y2: 3.376,
          gradientUnits: 'userSpaceOnUse',
        },
        /*#__PURE__*/ React.createElement('stop', {
          stopColor: '#536EED',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.25,
          stopColor: '#54C3EC',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.56,
          stopColor: '#64D769',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 1,
          stopColor: '#FECF2C',
        }),
      ),
    ),
  );
});
swishSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var swish = {
  category: 'brand',
  colorable: false,
  name: 'swish',
  svg: swishSvg,
};
